import { render, staticRenderFns } from "./AdminPageInfo.vue?vue&type=template&id=a1d258e2&scoped=true"
import script from "./AdminPageInfo.vue?vue&type=script&lang=ts"
export * from "./AdminPageInfo.vue?vue&type=script&lang=ts"
import style0 from "./AdminPageInfo.vue?vue&type=style&index=0&id=a1d258e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d258e2",
  null
  
)

export default component.exports